import {
	blackColor,
	blackColors,
	dangerColor,
	grayColor,
	hexToRgb,
	infoColor,
	primaryColor,
	roseColor,
	secondaryColor,
	successColor,
	support1Color,
	support2Color,
	support3Color,
	warningColor,
	whiteColor,
} from 'assets/jss/material-dashboard-pro-react';

const cardsColors = [
	['primary', primaryColor[0], primaryColor[1]],
	['secondary', secondaryColor[0], secondaryColor[1]],
	['support1', support1Color[0], support1Color[1]],
	['support2', support2Color[0], support2Color[1]],
	['support3', blackColors[1], support3Color[0]],
	['info', infoColor[0], infoColor[1]],
	['success', successColor[0], successColor[1]],
	['warning', warningColor[0], warningColor[1]],
];

const cardsColorsStyle = cardsColors.reduce(
	(styles, [name, gradientColor, gradientColor1]) => ({
		...styles,
		[name]: {
			background: `linear-gradient(to top, ${gradientColor}, ${gradientColor1})`,
			boxShadow: `0 4px 4px 0 rgba(${hexToRgb(blackColor)}, 0.14), 0 7px 10px -5px ${gradientColor}`,
			color: whiteColor,
		},
	}),
	{}
);

const cardStyle = {
	card: {
		border: '0',
		marginBottom: 16,
		marginTop: 16,
		borderRadius: '4px',
		color: 'rgba(' + hexToRgb(blackColor) + ', 0.87)',
		background: whiteColor,
		width: '100%',
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		minWidth: '0',
		wordWrap: 'break-word',
		fontSize: '.875rem',
	},
	cardPlain: {
		background: 'transparent',
		boxShadow: 'none',
	},
	cardProfile: {
		marginTop: '30px',
		textAlign: 'center',
	},
	cardBlog: {
		marginTop: '60px',
	},
	cardRaised: {
		boxShadow: `
      0 7px 8px 0 rgba(${hexToRgb(blackColor)}, 0.054),
      0 5px 22px 4px rgba(${hexToRgb(blackColor)}, 0.036),
      0 12px 17px 2px rgba(${hexToRgb(blackColor)}, 0.042)
      !important
    `,
		'&:after': {
			width: '100%',
			content: '""',
			borderRadius: '4px',
			zIndex: '-1',
			position: 'absolute',
			height: '100%',
		},
	},
	cardBackground: {
		backgroundPosition: 'center center',
		backgroundSize: 'cover',
		textAlign: 'center',
		'&:after': {
			position: 'absolute',
			zIndex: '1',
			width: '100%',
			height: '100%',
			display: 'block',
			left: '0',
			top: '0',
			content: '""',
			backgroundColor: 'rgba(' + hexToRgb(blackColor) + ', 0.56)',
			borderRadius: '6px',
		},
		'& small': {
			color: 'rgba(' + hexToRgb(whiteColor) + ', 0.7) !important',
		},
	},
	cardPricing: {
		textAlign: 'center',
		'&:after': {
			backgroundColor: 'rgba(' + hexToRgb(blackColor) + ', 0.7) !important',
		},
		'& ul': {
			listStyle: 'none',
			padding: 0,
			maxWidth: '240px',
			margin: '10px auto',
		},
		'& ul li': {
			color: grayColor[0],
			textAlign: 'center',
			padding: '12px 0px',
			borderBottom: '1px solid rgba(' + hexToRgb(grayColor[0]) + ',0.3)',
		},
		'& ul li:last-child': {
			border: 0,
		},
		'& ul li b': {
			color: grayColor[2],
		},
		'& h1': {
			marginTop: '30px',
		},
		'& h1 small': {
			display: 'inline-flex',
			height: 0,
			fontSize: '18px',
		},
		'& h1 small:first-child': {
			position: 'relative',
			top: '-17px',
			fontSize: '26px',
		},
		'& ul li svg, & ul li .fab,& ul li .fas,& ul li .far,& ul li .fal,& ul li .material-icons': {
			position: 'relative',
			top: '7px',
		},
	},
	cardPricingColor: {
		'& ul li': {
			color: whiteColor,
			borderColor: 'rgba(' + hexToRgb(whiteColor) + ',0.3)',
			'& b, & svg,& .fab,& .fas,& .far,& .fal,& .material-icons': {
				color: whiteColor,
				fontWeight: '700',
			},
		},
	},
	cardProduct: {
		marginTop: '30px',
	},
	...cardsColorsStyle,
	danger: {
		background: 'linear-gradient(60deg,' + dangerColor[1] + ',' + dangerColor[4] + ')',
		'& h1 small': {
			color: 'rgba(' + hexToRgb(whiteColor) + ', 0.8)',
		},
		color: whiteColor,
	},
	rose: {
		background: 'linear-gradient(60deg,' + roseColor[1] + ',' + roseColor[4] + ')',
		'& h1 small': {
			color: 'rgba(' + hexToRgb(whiteColor) + ', 0.8)',
		},
		color: whiteColor,
	},
	cardChart: {
		'& p': {
			marginTop: '0px',
			paddingTop: '0px',
		},
	},
	cardLogin: {
		transform: 'translate3d(' + hexToRgb(blackColor) + ')',
		transition: 'all 300ms linear',
	},
};

export default cardStyle;
